export default {
  Btn_Common: {
    TuoZhuai: 'Drag',
    QueDing: 'Confirm',
    QuXiao: 'Cancel',
    XinZeng_ZhuanJieMa: 'Add promotion',
    XiuGai_ZhuanJieMa: 'Edit promotion',
    XiuGai: 'Edit',
    Chufang_Yulan: 'Preview',
    DengRu: 'Sign in',
    ChaXun: 'Search',
    ChongZhi: 'Reset',
    XinZeng: 'Add',
    FenPei_JueSe: 'Roles',
    PaiBan_HaoYuan: 'Source',
    ChongZhi_MiMa: 'Reset password',
    QueRen: 'Confirm',
    GuanBi: 'Close',
    FuZhi: 'Copy',
    FuZhi_QuanBu: 'Copy all',
    ZhanTie: 'Paste',
    BaoCun: 'Save',
    YiSheng_Duan: 'Doctor terminal',
    XiuGai_ZhangHao_MiMa: 'Account&Password',
    TuiChu_DengLu: 'Log out',
    ShuaXin: 'Refresh',
    GuanBi_QiTa: 'Close others',
    GuanBi_SuoYou: 'Close all',
    XinZeng_JueSe: 'Add role',
    FenPei_QuanXian: 'Assign',
    ShanChu: 'Delete',
    XiuGai_JueSe: 'Edit role',
    XinZeng_YouHuiQuan: 'Add coupon',
    FaFang: 'Issue',
    PeiSong: 'Distribution',
    TianJia_DiZhi: 'Add address',
    XiaZai: 'Download',
    XinZeng_DingDan: 'Add order',
    ShenPi: 'Examine',
    QianShou: 'Signfor',
    WanJie: 'Complete',
    QianShou_JiLu: 'Signature record',
    ShenHe: 'Examine',
    XuanZe_YaoPin: 'Select medicine',
    QingKong_DingDan: 'Clear',
    ZanCun: 'Temporarily',
    TiJiao: 'Submit',
    Shang_Yi_Bu: 'Previous',
    QingChu: 'Clear',
    ShangChuan: 'Upload',
    YuLan: 'Preview',
    YuLan_Hou_TiJiao: 'Preview',
    XiuGai_MiMa: 'Edit password',
    XuanZe_XueWei: 'Select acupoints',
    XinZeng_YaoPin: 'Synchronous',
    TongBu: 'Synchronous',
    ShouFei_ZongJie: 'Charges',
    TongBu_GengXin: 'Update',
    XinZeng_ShangPin: 'Add product',
    XinZeng_BingRen: 'Add',
    XinZeng_TaoPiao: 'Add setmeal',
    TianRu: 'Fill in',
    QuanBu_XuanZhong: 'Select All',
    QuXiao_XuanZhong: 'Deselect All',
    ShengCheng_HaoYuan: '生成號源',
    XinZeng_ZhenSuo: 'Add',
    XiuGai_ZhenSuo: 'Edit',
    PeiZhi: 'Configure',
    SouXun: 'Search',
    PiCi: 'Batch No.',
    XiuGai_YaoPin: 'Edit Medicine',
    YaoPin: 'Medicine',
    WanCheng: 'Completed',
    TianJia_ZuiXinJiLu: 'Add',
    BianJi_ZuiJinJiLu: 'Edit',
  },
}
